import React, { createContext, useEffect, useState } from 'react'

export const PrintContext = createContext()

export const PrintProvider = ({ children }) => {
  const [printData, setPrintData] = useState([])
  // console.log(printData)
  return <PrintContext.Provider value={[printData, setPrintData]}>{children}</PrintContext.Provider>
}
